import type { i18n } from '@wix/fe-essentials/i18n';
import { type TOptions } from 'i18next';
import { createContext, useContext } from 'react';

export { Trans } from '@wix/wix-i18n-config';
export type { i18n } from '@wix/fe-essentials/i18n';

// Workaround for https://github.com/isaachinman/next-i18next/issues/1781
export type TFunction = (key: string, options?: TOptions | string) => string;

export interface TranslationProps {
  i18n: i18n;
  t: TFunction;
}

export const TranslationContext = createContext<TranslationProps | undefined>(
  undefined,
);

export function useTranslation() {
  const context = useContext(TranslationContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
}
